import { Twitter } from '@mui/icons-material';
import { Avatar, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import '../../styles/scrollingBanner.css';

const ScrollingTweetBanner = ({ images, speed = 5000, direction }) => {
    return (
        <div className="inner p-4">
            <div className="wrapper items-center">
            {
                new Array(3).fill('').map(() => 
                    <section className={`${direction === 'forward'? 'section-forward': 'section-backward'}`} style={{ "--speed": `${speed}ms` }}>
                        {images.map(({ id, image }) => (
                            <div key={id} className='px-3 relative'>
                                <Box className="image rounded-2xl p-4 md:p-5 w-64 h-full md:w-72 lg:w-80 max-h-56 overflow-hidden shadow-lg bg-[#fffdd4] text-[#231F11] hover:text-[#FFFDD4] border border-[#fffdd4] cursor-pointer hover:bg-[#231F11] ">
                                    <Box
                                        className='flex flex-col gap-2 h-auto max-h-[100%] overflow-hidden'
                                    >
                                        <Stack direction='row' justifyContent='space-between'>
                                            <Stack direction='row' gap={1}>
                                                <Avatar
                                                    alt='Twitter User' src={image}
                                                    sx={{
                                                        width: {
                                                            xs: 40,
                                                            md: 50
                                                        },
                                                        height: {
                                                            xs: 40,
                                                            md: 50
                                                        }
                                                    }}
                                                />
                                                <Stack>
                                                    <Typography
                                                        sx={{
                                                            fontSize: {
                                                                xs: 14,
                                                                md: 16
                                                            },
                                                            fontWeight: '600'
                                                        }}
                                                    >{'Kene Nnakwue yue'.slice(0,14)}</Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: {
                                                                xs: 13,
                                                                md: 15
                                                            },
                                                            fontWeight: '300'
                                                        }}
                                                    >@kenny_nnakwue</Typography>
                                                </Stack>
                                            </Stack>
                                            <Avatar  sx={{ bgcolor: '#231F11'}}>
                                                <Twitter />
                                            </Avatar>
                                        </Stack>
                                        <Typography variant='body2'>
                                            Lorem ipsum dolor sit manet exesiam norem patri...
                                            Pater Nostra qui est in caeli. Lorem nora poque in saecula...
                                            Lorem ipsum dolor sit manet exesiam norem patri...
                                            Pater Nostra qui est in caeli. Lorem nora poque in saecula...
                                        </Typography>
                                    </Box>
                                </Box>
                            </div>
                        ))}
                    </section>
                )
            }
            </div>
        </div>
    );
};

export default ScrollingTweetBanner;
